import { gql } from '@apollo/client';

const GET_DE_DUPLICATED_METRIC_DOCUMENT_FILE_URL = gql`
  query GetDeDuplicatedMetricDocumentFileUrl($fileName: String!) {
    deDuplicatedMetricDocumentFileUrl(fileName: $fileName)
  }
`;

export default GET_DE_DUPLICATED_METRIC_DOCUMENT_FILE_URL;
